const TEST_IDS = {
  fromTokenSelectTokenTextField: 'from-token-select-token-text-field',
  fromTokenMaxButton: 'from-token-max-button',
  toTokenSelectTokenTextField: 'to-token-select-token-text-field',
  switchTokensButton: 'switch-tokens-button',
  swapDetails: 'swap-details',
};

export default TEST_IDS;
